// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__248Yx","content":"RecentSearches_content__1AEsc"};